function whoami(args) {
  return "whoami";
}

export { whoami };
